<template>
    <div>
        <!-- Detalhe Orçamento -->
        <div class="modal fade" id="detalheOrcamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Orçamento</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state msg="Orçamento não identificado" v-if="!orcamento" />

                        <template v-else-if="orcamento && orcamento.js_procedimentos">
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    <div class="lead">
                                        {{ orcamento.st_titulo }}
                                    </div>

                                    <div v-if="orcamento.paciente && orcamento.paciente.cadastro && orcamento.paciente.cadastro.telefones">
                                        <div v-if="orcamento.paciente.cadastro.telefones.telefone">
                                            <i class="fas fa-phone fa-fw mr-2"></i> 
                                            {{ orcamento.paciente.cadastro.telefones.telefone }}
                                        </div>
                                        <div v-if="orcamento.paciente.cadastro.telefones.celular">
                                            <i class="fa-solid fa-mobile-screen-button fa-fw mr-2"></i>
                                            {{ orcamento.paciente.cadastro.telefones.celular }}
                                        </div>
                                        <div v-if="orcamento.paciente.cadastro.st_email">
                                            <i class="fa-regular fa-envelope-open fa-fw mr-2"></i>
                                            {{ orcamento.paciente.cadastro.st_email }}
                                        </div>
                                    </div>

                                    <div v-else-if="!orcamento.paciente">
                                        <div v-if="orcamento.st_celular">
                                            <i class="fa-solid fa-mobile-screen-button fa-fw mr-2"></i>
                                            {{ orcamento.st_celular }}
                                        </div>
                                        <div v-if="orcamento.st_email">
                                            <i class="fa-regular fa-envelope-open fa-fw mr-2"></i>
                                            {{ orcamento.st_email }}
                                        </div>
                                    </div>
                                </div>

                                <div>#{{ orcamento.id_orcamento }}</div>
                            </div>

                            <tabela-orcamento :procedimentos="orcamento.js_procedimentos" :pode_ver_valor="true" />

                            <hr>

                            <relatorios-linkados 
                                pagina="crm-orcamentos" 
                                :apenas_links="true"
                                :parms="{ orcamento_id: [orcamento.id_orcamento] }" />
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="ir_para()">Abrir Orçamento</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import TabelaOrcamento from './TabelaOrcamento.vue';
import RelatoriosLinkados from '../../relatorios/shared/RelatoriosLinkados.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            orcamento: null, 
        }
    },

    components: { 
        TabelaOrcamento,
        RelatoriosLinkados,
        AzEmptyState, 
    },

    methods: { 
        ir_para () { 
            $('.modal').modal('hide');
            this.$router.push({ name: 'rorcamento', params: { id_orcamento: this.orcamento.id_orcamento }});
        },

        abrir(id_orcamento) { 

            this.orcamento = null;

            $('#detalheOrcamentoModal').modal('show');

            this.$util.load(this, { 
                service: 'orcamentos', 
                func: 'show',
                parms: { 
                    id: id_orcamento,
                    orcamento: true, 
                },
                loadTo: res => { 
                    this.orcamento = res; 
                }
            })
        }
    }
}
</script>
